const money = (amount) =>{
    return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(amount)
}
module.exports = {
    money:money
}
